import{d as t}from"./chunk-UHFZTYDX.js";import{q as a}from"./chunk-WFWW2WKK.js";import{b as s,c as r}from"./chunk-7TW5V77R.js";import{m as o}from"./chunk-HBP5N4FR.js";o();a();var l=()=>{let e=t(s),c=t(r);return{customToasts:e,transactionToasts:c}};export{l as a};
//# sourceMappingURL=chunk-R4SO2GZC.js.map
